<div id="sexta-finales" class="tab-content">
    <div class="grid">
        <div class="card">
            <div class="card-header">
                <h3>Finales</h3>
                <div class="group-actions" *ngIf="esAdmin$ | async">
                    <a (click)="generarFinales()">Generar Finales</a>
                </div>
            </div>
            <div class="bracket">
                <div class="bracket-round" *ngIf="category?.hasQuarterFinals">
                    <h3>Cuartos de final</h3>

                    <div class="final-match" *ngFor="let match of quarterFinals; let i = index">
                        <div class="games">
                            <div *ngFor="let game of match.games" class="game-score">
                                <span class="player1-score">{{game.player1Points}}</span> -
                                <span class="player2-score">{{game.player2Points}}</span>
                            </div>
                        </div>
                        <div *ngIf="match.player1Bye; else player1Block" class="final-player loser">
                            <div class="player-avatar">BY</div>
                            <div class="player-name">BYE</div>
                            <div class="player-score">0</div>
                        </div>
                        <ng-template #player1Block>
                            <div class="final-player" [ngClass]="{
                                'winner': match.playerWinnerId && match.playerWinnerId === match.player1Id,
                                'loser': match.playerWinnerId && match.playerWinnerId !== match.player1Id
                            }">
                                <div class="player-avatar" *ngIf="match.player1">{{match.player1.playerLabel}}</div>
                                <div class="player-avatar no-avatar" *ngIf="!match.player1">
                                    <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                                </div>
                                <div class="player-name">{{match.player1 ? match.player1.playerName :
                                    match.player1Label}}</div>
                                <div class="player-score">{{match.player1MatchesWon}}</div>
                                <div class="matches-actions" *ngIf="esAdmin$ | async">
                                    <a (click)="setEndPlayer('quarterFinals', i, 1)">Set player</a>
                                    <div style="color: #ff6b35; font-weight: 600;">{{match.player1Id}}</div>
                                </div>
                            </div>
                        </ng-template>

                        <div *ngIf="match.player2Bye; else player2Block" class="final-player loser">
                            <div class="player-avatar">BY</div>
                            <div class="player-name">BYE</div>
                            <div class="player-score">0</div>
                        </div>
                        <ng-template #player2Block>
                            <div class="final-player" [ngClass]="{
                                'winner': match.playerWinnerId && match.playerWinnerId === match.player2Id,
                                'loser': match.playerWinnerId && match.playerWinnerId !== match.player2Id
                            }">
                                <div class="player-avatar" *ngIf="match.player2">{{match.player2.playerLabel}}</div>
                                <div class="player-avatar no-avatar" *ngIf="!match.player2">
                                    <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                                </div>
                                <div class="player-name">{{match.player2 ? match.player2.playerName :
                                    match.player2Label}}</div>
                                <div class="player-score">{{match.player2MatchesWon}}</div>
                                <div class="matches-actions" *ngIf="esAdmin$ | async">
                                    <a (click)="setEndPlayer('quarterFinals', i, 2)">Set player</a>
                                    <div style="color: #ff6b35; font-weight: 600;">{{match.player2Id}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="bracket-round" *ngIf="category?.hasSemiFinals">
                    <h3>Semifinales</h3>

                    <div class="final-match" *ngFor="let match of semiFinals; let i = index">
                        <div class="games">
                            <div *ngFor="let game of match.games" class="game-score">
                                <span class="player1-score">{{game.player1Points}}</span> -
                                <span class="player2-score">{{game.player2Points}}</span>
                            </div>
                        </div>
                        <div *ngIf="match.player1Bye; else player1Block" class="final-player loser">
                            <div class="player-avatar">BY</div>
                            <div class="player-name">BYE</div>
                            <div class="player-score">0</div>
                        </div>
                        <ng-template #player1Block>
                            <div class="final-player" [ngClass]="{
                                'winner': match.playerWinnerId && match.playerWinnerId === match.player1Id,
                                'loser': match.playerWinnerId && match.playerWinnerId !== match.player1Id
                            }">
                                <div class="player-avatar" *ngIf="match.player1">{{match.player1.playerLabel}}</div>
                                <div class="player-avatar no-avatar" *ngIf="!match.player1">
                                    <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                                </div>
                                <div class="player-name">{{match.player1 ? match.player1.playerName :
                                    match.player1Label}}</div>
                                <div class="player-score">{{match.player1MatchesWon}}</div>
                                <div class="matches-actions" *ngIf="esAdmin$ | async">
                                    <a (click)="setEndPlayer('semiFinals', i, 1)">Set player</a>
                                    <div style="color: #ff6b35; font-weight: 600;">{{match.player1Id}}</div>
                                </div>
                            </div>
                        </ng-template>

                        <div *ngIf="match.player2Bye; else player2Block" class="final-player loser">
                            <div class="player-avatar">BY</div>
                            <div class="player-name">BYE</div>
                            <div class="player-score">0</div>
                        </div>
                        <ng-template #player2Block>
                            <div class="final-player" [ngClass]="{
                                'winner': match.playerWinnerId && match.playerWinnerId === match.player2Id,
                                'loser': match.playerWinnerId && match.playerWinnerId !== match.player2Id
                            }">
                                <div class="player-avatar" *ngIf="match.player2">{{match.player2.playerLabel}}</div>
                                <div class="player-avatar no-avatar" *ngIf="!match.player2">
                                    <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                                </div>
                                <div class="player-name">{{match.player2 ? match.player2.playerName :
                                    match.player2Label}}</div>
                                <div class="player-score">{{match.player2MatchesWon}}</div>
                                <div class="matches-actions" *ngIf="esAdmin$ | async">
                                    <a (click)="setEndPlayer('semiFinals', i, 2)">Set player</a>
                                    <div style="color: #ff6b35; font-weight: 600;">{{match.player2Id}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="bracket-round finals-round" *ngIf="category?.hasFinal">
                    <h3>Final</h3>

                    <div class="final-match" style="margin-top: 3.5rem;" *ngIf="final">
                        <div class="games">
                            <div *ngFor="let game of final.games" class="game-score">
                                <span class="player1-score">{{game.player1Points}}</span> -
                                <span class="player2-score">{{game.player2Points}}</span>
                            </div>
                        </div>
                        <div class="final-player" [ngClass]="{
                                'winner': final.playerWinnerId && final.playerWinnerId === final.player1Id,
                                'loser': final.playerWinnerId && final.playerWinnerId !== final.player1Id
                            }">

                            <div class="player-avatar" *ngIf="final.player1">{{final.player1.playerLabel}}</div>
                            <div class="player-avatar no-avatar" *ngIf="!final.player1">
                                <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                            </div>
                            <div class="player-name">{{final.player1 ? final.player1.playerName :
                                final.player1Label}}</div>
                            <div class="player-score">{{final.player1MatchesWon}}</div>
                            <div class="matches-actions" *ngIf="esAdmin$ | async">
                                <a (click)="setEndPlayer('final', 0, 1)">Set player</a>
                                <div style="color: #ff6b35; font-weight: 600;">{{final.player1Id}}</div>
                            </div>
                        </div>

                        <div class="final-player" [ngClass]="{
                                'winner': final.playerWinnerId && final.playerWinnerId === final.player2Id,
                                'loser': final.playerWinnerId && final.playerWinnerId !== final.player2Id
                            }">
                            <div class="player-avatar" *ngIf="final.player2">{{final.player2.playerLabel}}</div>
                            <div class="player-avatar no-avatar" *ngIf="!final.player2">
                                <img src="images/no-avatar.png" alt="Logo Sponsor" class="sponsor-logo">
                            </div>
                            <div class="player-name">{{final.player2 ? final.player2.playerName :
                                final.player2Label}}</div>
                            <div class="player-score">{{final.player2MatchesWon}}</div>
                            <div class="matches-actions" *ngIf="esAdmin$ | async">
                                <a (click)="setEndPlayer('final', 0, 2)">Set player</a>
                                <div style="color: #ff6b35; font-weight: 600;">{{final.player2Id}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="champion-trophy">
                        <div class="trophy-icon">🏆</div>
                        <div class="champion-text">
                            <span *ngIf="final && final.playerWinnerId" style="color:#ff6b35">
                                {{
                                    final.playerWinnerId === final.player1Id
                                        ? (final.player1?.playerName || final.player1Label)
                                        : (final.player2?.playerName || final.player2Label)
                                }}
                            </span>
                            <span *ngIf="!final || !final.playerWinnerId" style="color:#ff6b35">
                                CAMPEÓN
                            </span>
                        </div>
                        <div class="matches-actions" *ngIf="esAdmin$ | async">
                            <a (click)="setEndPlayer('champion', 0, 0)">Set campeón</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>